// extracted by mini-css-extract-plugin
export var campanyName = "footer-module--campanyName--ac135";
export var copyright = "footer-module--copyright--57782";
export var footer = "footer-module--footer--e808d";